import { Box, ButtonGroup, Container, HStack, IconButton, useTheme, Text } from '@chakra-ui/react';
import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

interface Props {
  nextLink: string | null;
  prevLink: string | null;
  onNext: () => void;
  onPrev: () => void;
  pageNumber: string | null;
  totalPages: number | null;
}

const Pagination = ({
  nextLink,
  prevLink,
  onNext,
  onPrev,
  pageNumber,
  totalPages,
}: Props): JSX.Element => {
  const theme = useTheme();
  const hasPagination = nextLink || prevLink || (totalPages && Math.ceil(totalPages) > 1);
  if (!hasPagination) return <></>;

  const currentPage = parseInt(pageNumber ?? '1');
  const totalPageCount = Math.ceil(totalPages ?? 0);

  // Determine if prev/next should be enabled based on page position
  // Use links if available, otherwise calculate based on page numbers
  const hasPrev = prevLink !== null || (currentPage > 1 && totalPages !== null);
  const hasNext = nextLink !== null || (currentPage < totalPageCount && totalPages !== null);

  return (
    <Box bg="bg-surface">
      <Container>
        <Text textAlign="center" fontSize="16px">{`Page ${pageNumber} of ${totalPageCount}`}</Text>
        <HStack justify="center">
          <ButtonGroup isAttached variant="ghost">
            <IconButton
              value="left"
              aria-label="Show previous"
              px="14px"
              _hover={{
                background: 'gray.100',
              }}
              icon={<ChevronLeftIcon fontSize="16px" />}
              color={!hasPrev ? theme.colors.text[100] : theme.colors.mainText}
              pointerEvents={!hasPrev ? 'none' : 'auto'}
              onClick={onPrev}
            />
            <IconButton
              borderColor="gray.200"
              value="right"
              aria-label="Show next"
              px="14px"
              _hover={{
                background: 'gray.100',
              }}
              icon={<ChevronRightIcon fontSize="16px" />}
              color={!hasNext ? theme.colors.text[100] : theme.colors.mainText}
              pointerEvents={!hasNext ? 'none' : 'auto'}
              onClick={onNext}
            />
          </ButtonGroup>
        </HStack>
      </Container>
    </Box>
  );
};

export default Pagination;
